// import { Button, DataGrid } from "devextreme-react";
// import {
//   Column,
//   ColumnChooser,
//   Export,
//   FilterPanel,
//   FilterRow,
//   GroupItem,
//   GroupPanel,
//   HeaderFilter,
//   Item,
//   LoadPanel,
//   Lookup,
//   Pager,
//   Paging,
//   SearchPanel,
//   Summary,
//   Toolbar,
// } from "devextreme-react/data-grid";
import React, { useEffect } from "react";
import Header from "../../common/Header";

// import {
//   CLINIC_STEP_NAME,
//   CLST_PRPOS_CD_NM,
//   DMINT_DIVS_CD_NM,
//   CLNC_TEST_DTL_CD_NM,
//   RNDM_ASSG_CD_NM,
//   BLND_CD_NM,
//   YN,
// } from "./data";
// import { malgun } from "../malgun";

// import axios from "axios";
// import jsPDF from "jspdf";
// import "jspdf-autotable";
// import { exportDataGrid as exportDataGridToPDF } from "devextreme/pdf_exporter";
// import { Workbook } from "exceljs";
// import { saveAs } from "file-saver-es";
// import { exportDataGrid } from "devextreme/excel_exporter";
// import CustomStore from "devextreme/data/custom_store";
import MdcinClincTestInfoService01Grid from "./MdcinClincTestInfoService01Grid";

export default function MdcinClincTestInfoService01(props) {
  // const [dataSource, setDataSource] = useState(null);
  // const [value, setValue] = useState(null);
  // const [gridFilterValue, setGridFilterValue] = useState(null);
  // const [filterValue, setFilterValue] = useState(null);

  const dataGridRef = React.createRef();
  // const pageSize = [10, 20, 50, 100];

  useEffect(() => {
    document.title = "의약품 임상시험 정보";

    // setDataSource(
    //   new CustomStore({
    //     key: "id",
    //     load: async () => {
    //       const result = await axios.get(
    //         `${process.env.REACT_APP_BECCO_API_URL}/api/mdcinClincTestInfoService01`
    //       );

    //       return result.data;
    //     },
    //   })
    // );
  }, []);

  // const onFocusedRowChanged = (e) => {};

  // const buttonClick = () => {
  //   setGridFilterValue(value);
  // };

  // const exportGrid = React.useCallback(() => {
  //   const doc = new jsPDF("l", "mm", [297, 210]);

  //   doc.addFileToVFS("malgun.ttf", malgun);
  //   doc.addFont("malgun.ttf", "malgun", "normal");
  //   doc.setFont("malgun");

  //   const dataGrid = dataGridRef.current.instance;

  //   exportDataGridToPDF({
  //     jsPDFDocument: doc,
  //     component: dataGrid,
  //     autoTableOptions: {
  //       styles: {
  //         font: "malgun",
  //       },
  //     },
  //   }).then(() => {
  //     doc.save("식품의약품안전처_의약품 임상시험 정보.pdf");
  //   });
  // });

  // const linkClinicalTrialsGov = React.useCallback(() => {
  //   window.open(`https://clinicaltrials.gov`);
  // });

  // const onExporting = (e) => {
  //   const workbook = new Workbook();
  //   const worksheet = workbook.addWorksheet("의약품 임상시험 정보");

  //   exportDataGrid({
  //     component: e.component,
  //     worksheet,
  //     autoFilterEnabled: true,
  //   }).then(() => {
  //     workbook.xlsx.writeBuffer().then((buffer) => {
  //       saveAs(
  //         new Blob([buffer], {
  //           type: "application/octet-stream",
  //         }),
  //         "식품의약품안전처_의약품 임상시험 정보.xlsx"
  //       );
  //     });
  //   });

  //   e.cancel = true;
  // };

  // const onOptionChanged = (e) => {
  //   if (e.fullName === "filterValue") {
  //     if (e.value) {
  //       if (Array.isArray(e.value[e.value.length - 1])) {
  //         e.value.forEach((element) => {
  //           if (Array.isArray(element)) {
  //             if (typeof element[2] === "string") {
  //               element[2] = element[2].trim();
  //             }
  //           }
  //         });
  //       } else {
  //         e.value[e.value.length - 1] = e.value[e.value.length - 1].trim();
  //       }
  //     }

  //     applyFilter(e.value);
  //   }
  // };

  // const applyFilter = (filterExpression) => {
  //   setFilterValue(filterExpression);
  // };

  // const onContentReady = async (e) => {
  //   const filterExpr = e.component.getCombinedFilter(true);

  //   if (filterExpr) {
  //     await axios.post(
  //       `${process.env.REACT_APP_BECCO_API_URL}/api/mdcinClincTestInfoService01/FILTER_VALUE`,
  //       {
  //         filterValue: filterExpr.join(),
  //       }
  //     );
  //   }
  // };

  return (
    <React.Fragment>
      <Header
        // title={"식품의약품안전처 의약품 임상시험 정보"}
        title="NEW DRUG CLINICAL TRIAL INFO."
        menuDataSource={null}
      />
      {/* <h1
        style={{
          color: "#1B4452",
          marginBlockStart: "0.67em",
          marginBlockEnd: "0.67em",
          marginInlineStart: "0px",
          marginInlineEnd: "0px",
        }}
      >
        식품의약품안전처 의약품 임상시험 정보
      </h1> */}
      <MdcinClincTestInfoService01Grid />
      {/* <div className="filter-container">
        <FilterBuilder
          fields={fields}
          value={value}
          onValueChanged={onValueChanged}
        />
        <Button text="Apply Filter" type="default" onClick={buttonClick} />
        <div className="dx-clearfix" />
      </div> */}
      {/* <DataGrid
        id="MdcinClincTestInfoService01Grid"
        ref={dataGridRef}
        dataSource={dataSource}
        keyExpr="id"
        rowAlternationEnabled={true}
        showBorders={true}
        showColumnLines={true}
        focusedRowEnabled={true}
        // filterValue={gridFilterValue}

        filterValue={filterValue}
        allowColumnResizing={true}
        columnAutoWidth={true}
        onExporting={onExporting}
        onFocusedRowChanged={onFocusedRowChanged}
        onOptionChanged={onOptionChanged}
        onContentReady={onContentReady}
      >
        <ColumnChooser enabled={true} />
        <LoadPanel enabled={true} />

        <Toolbar>
          <Item location="before" name="groupPanel" />
          <Item location="after">
            <Button
              icon="https://clinicaltrials.gov/ct2/html/images/favicon.ico"
              // text="ClinicalTrials.gov"
              onClick={linkClinicalTrialsGov}
            />
          </Item>
          <Item location="after">
            <Button icon="exportpdf" onClick={exportGrid} />
          </Item>
          <Item name="exportButton" />
          <Item name="columnChooserButton" />
          <Item name="searchPanel" />
        </Toolbar>

        <Export enabled={true} />

        <Summary>
          <GroupItem column="APPLY_ENTP_NAME" summaryType="count" />
        </Summary>

        <Pager
          allowedPageSizes={pageSize}
          showPageSizeSelector={true}
          showInfo={true}
        />
        <Paging enabled={true} defaultPageSize={10} />

        <FilterRow visible={true} />
        <HeaderFilter visible={true} />

        <FilterPanel visible={true} />
        <GroupPanel visible={true} />
        <SearchPanel visible={true} highlightCaseSensitive={true} />

        <Column
          dataField="APPLY_ENTP_NAME"
          caption="신청자"
          dataType="string"
          // width={200}
        />
        <Column
          dataField="RPRSV_NMP"
          caption="임상시험 대표자"
          dataType="string"
        />
        <Column dataField="ADDR" caption="임상시험 소재지" dataType="string" />
        <Column
          dataField="ORGN_DEV_BSSH_NM"
          caption="원개발사"
          dataType="string"
          // width={200}
        />
        <Column
          dataField="ORGN_DEV_NATN_CD_NM"
          caption="원개발사 국가"
          dataType="string"
        />
        <Column
          dataField="HIST_REG_DT"
          caption="최근(변경)승인일자"
          dataType="date"
          width={150}
          format="yyyy-MM-dd"
        />
        <Column
          dataField="APPROVAL_TIME"
          caption="승인일"
          dataType="date"
          width={150}
          format="yyyy-MM-dd"
        />
        <Column
          dataField="LAB_NAME"
          caption="실시기관[시험책임자]"
          dataType="string"
        />
        <Column
          dataField="GOODS_NAME"
          caption="제품명"
          dataType="string"
          // width={200}
        />
        <Column dataField="GNRL_CD_NM" caption="성분명" dataType="string" />
        <Column
          dataField="CLINIC_EXAM_TITLE"
          caption="시험제목"
          dataType="string"
          width={500}
        />
        <Column
          dataField="CLINIC_EXAM_ENG_TITLE"
          caption="시험제목 (영문)"
          dataType="string"
          width={500}
        />
        <Column
          dataField="IVSGT_PURPS"
          caption="목적"
          dataType="string"
          width={500}
        />
        <Column dataField="CLST_PRPOS_CD_NM" caption="용도" dataType="string">
          <Lookup
            dataSource={CLST_PRPOS_CD_NM}
            displayExpr="name"
            valueExpr="name"
          />
        </Column>
        <Column
          dataField="DMINT_DIVS_CD_NM"
          caption="국내/국외개발"
          dataType="string"
        >
          <Lookup
            dataSource={DMINT_DIVS_CD_NM}
            displayExpr="name"
            valueExpr="name"
          />
        </Column>
        <Column
          dataField="CLNC_TEST_DTL_CD_NM"
          caption="상세구분 (다국가)"
          dataType="string"
        >
          <Lookup
            dataSource={CLNC_TEST_DTL_CD_NM}
            displayExpr="name"
            valueExpr="name"
          />
        </Column>
        <Column
          dataField="TRGT_DISS_CD_NM"
          caption="대상질환"
          dataType="string"
        />
        <Column
          dataField="TRGT_DISS_DTL_CD_NM"
          caption="대상질환 상세"
          dataType="string"
        />
        <Column
          dataField="TRGT_DISS_DTL_ETC"
          caption="대상질환 기타 직접입력"
          dataType="string"
        />
        <Column
          dataField="TRGT_DISS_NM"
          caption="대상질환명 (적응증)"
          dataType="string"
          width={500}
        />
        <Column
          dataField="DMST_PRMSN_YN"
          caption="국내허가여부"
          dataType="string"
        >
          <Lookup dataSource={YN} displayExpr="name" valueExpr="name" />
        </Column>
        <Column
          dataField="COMP_DRUG_YN"
          caption="활성대조약여부"
          dataType="string"
        >
          <Lookup dataSource={YN} displayExpr="name" valueExpr="name" />
        </Column>
        <Column
          dataField="FRST_INDV_TRGT_IVSGT_YN"
          caption="최초사람대상여부"
          dataType="string"
        >
          <Lookup dataSource={YN} displayExpr="name" valueExpr="name" />
        </Column>
        <Column dataField="CPDR_YN" caption="대조약여부" dataType="string">
          <Lookup dataSource={YN} displayExpr="name" valueExpr="name" />
        </Column>
        <Column dataField="PLCB_YN" caption="위약여부" dataType="string">
          <Lookup dataSource={YN} displayExpr="name" valueExpr="name" />
        </Column>
        <Column
          dataField="COMP_DRUG_NM"
          caption="대조약제품명"
          dataType="string"
        />
        <Column dataField="SHAPE_CD" caption="제형" dataType="string" />
        <Column
          dataField="CLINIC_STEP_NAME"
          caption="단계"
          datatype="string"
          // width={150}
        >
          <Lookup
            dataSource={CLINIC_STEP_NAME}
            displayExpr="name"
            valueExpr="name"
          />
        </Column>
        <Column
          dataField="CLINIC_TYPE_CD_NM"
          caption="임상시험형태"
          type="string"
        />
        <Column dataField="CLINICAL_PERIOD" caption="기간" type="string" />
        <Column
          dataField="TESTEE_CNT_INFO"
          caption="목표대상자수 (국내 대상자수)"
          type="string"
        />
        <Column
          dataField="RNDM_ASSG_CD_NM"
          caption="무작위배정여부"
          type="string"
        >
          <Lookup
            dataSource={RNDM_ASSG_CD_NM}
            displayExpr="name"
            valueExpr="name"
          />
        </Column>
        <Column dataField="BLND_CD_NM" caption="눈가림종류" type="string">
          <Lookup dataSource={BLND_CD_NM} displayExpr="name" valueExpr="name" />
        </Column>
        <Column
          dataField="ARBTR_GRP_NUM"
          caption="중재군수"
          type="number"
          alignment="right"
        />
        <Column
          dataField="CLST_BGNG_DT"
          caption="최초 시험대상자 선정일"
          dataType="date"
          width={150}
          format="yyyy-MM-dd"
        />
        <Column
          dataField="LAST_TRGTER_SLCTN_DT"
          caption="최종 시험대상자 선정일"
          dataType="date"
          width={150}
          format="yyyy-MM-dd"
        />
        <Column
          dataField="CLST_END_DT"
          caption="최종 시험대상자 관찰 종료일"
          dataType="date"
          width={150}
          format="yyyy-MM-dd"
        />
        <Column
          dataField="TEST_COMPLETION_DT"
          caption="실제 시험 완료일"
          dataType="date"
          width={150}
          format="yyyy-MM-dd"
        />
        <Column
          dataField="RESULT_REPORT_SUBMIT_DT"
          caption="결과보고 제출일"
          dataType="date"
          width={150}
          format="yyyy-MM-dd"
        />
        <Column
          dataField="PRIM_EVL_VAR"
          caption="1차 유효성 평가변수"
          type="string"
          width={500}
        />
        <Column
          dataField="SCND_EVL_VAR"
          caption="2차 유효성 평가변수"
          type="string"
          width={500}
        />
        <Column dataField="DOSAGE_TERM_TS" caption="투여기간" type="string" />
        <Column
          dataField="CLST_MTH_INFO"
          caption="투여방법"
          type="string"
          width={500}
        />
        <Column dataField="STATUS" caption="진행현황" type="string" />
        <Column
          dataField="HMPG_ADDR"
          caption="모집공고 확인 홈페이지 주소"
          dataType="string"
        />
      </DataGrid> */}
    </React.Fragment>
  );
}
